import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PublicRoute from "./components/PublicRoute";
import LoginPage from "./pages/Login/LoginPage";
import RequestAccessPage from "./pages/RequestAccess/RequestAccessPage";
import ConsolePage from "./pages/Console/ConsolePage";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes - redirect to console if already logged in */}
          <Route
            path="/"
            element={
              <PublicRoute>
                <LoginPage />
              </PublicRoute>
            }
          />

          <Route
            path="/request"
            element={
              <PublicRoute>
                <RequestAccessPage />
              </PublicRoute>
            }
          />

          {/* Protected Dashboard - All routes go through ConsolePage wrapper */}
          <Route
            path="/console/*"
            element={
              <ProtectedRoute>
                <ConsolePage />
              </ProtectedRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}